import type { InvoiceListItem } from '@klear/invoice/invoice-list.wire'
import type { FundingDocuments } from '@klear/invoice-offer/funding-documents'
import type { Receivable } from '@klear/invoice-offer/receivables'
import type { ProofOfAcceptanceListItem } from '@klear/proof-of-acceptance/proof-of-acceptance-list.wire'
import type { PurchaseOrderListItem } from '@klear/purchase-order/purchase-order-list.wire'

export const RECEIVABLE_DEFAULT_TERMS_DAYS = 45

export type ReceivableDocuments = FundingDocuments<InvoiceListItem, PurchaseOrderListItem, ProofOfAcceptanceListItem>

export type ReceivableRow = Receivable<InvoiceListItem, PurchaseOrderListItem, ProofOfAcceptanceListItem>
